
import React from 'react'
import { useEffect ,useState} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../../../components/User/Header/Header';
import Footer from '../../../components/User/Footer/Footer';
import HomeBanner from "../../../images/background/homeBanner.jpg"

function Blog() {

    const [blogs, setBlogs] = useState(null);
  const [showAddBlog, setShowAddBlog] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const ImageAPI = process.env.REACT_APP_IMAGE_URL;
  useEffect(() => {
    window.scrollTo(0,0)
    getAllBlogs();
  }, []);

  const getAllBlogs = () => {
    // const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}/CMB/GETBlogs?id=0`, {
        headers: {
        //   Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        console.log(response.data.data)
        setBlogs(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  };

  const getCurrentBlogImage = (image) => {
return `${ImageAPI}Images/Blogs/${image}`;
  };

const formatDate = (date) => {
  const dateString = new Date(date);
  return dateString.toLocaleDateString('en-US', { month: 'short', day: 'numeric',year:'numeric' });
};

  return (
    <section>
 <div class="page-wrapper">
    <Header/>
    <section
          class="call-to-action-one sp-four"
          style={{ backgroundImage: `url(${HomeBanner})` }}
        >
          <div class="container">
            <div class="sec-title-one white text-center">
              {/* <h5>Keep Runing</h5> */}
              <h2>Our Blogs</h2>
            </div>
            {/* <div class="text mt-20 mb-50">
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est <br /> laborum.sed ut
              perspiciatis unde.
            </div>
            <div class="link-btn">
              <a href="#" class="theme-btn btn-style-two">
                Get Appointment
              </a>
            </div> */}
          </div>
        </section>
        <section class="blog-section sp-seven">
            <div class="container">
                <div class="row">
                    {blogs && blogs.length>0?
blogs.map((blog,idx)=>{
    return <div  key={idx} class="news-block-one col-xl-4 col-lg-6 col-sm-12">
    <div class="inner-box">
        <Link to={`/blog/${blog.URL}`}>
        <div style={{cursor:'pointer'}} class="image">
            <img src={getCurrentBlogImage(blog.ImagePath)} alt={blog.ImagePath} />
            <a  href={`${ImageAPI}/Images/Blogs/${blog.ImagePath}`}> </a>
            <div class="overlay-link">
                <div class="">
                    <a href={`/blog/${blog.URL}`}></a>
                </div>                                
            </div>
        </div>
        </Link>
        <div class="lower-content">
            <h5><a href={`/blog/${blog.URL}`}>{blog.MetaTitle}</a></h5>
            <ul class="blog-info mt-15 mb-15">
                <li><i class="fa fa-calendar"></i>{formatDate(blog.Created_On)}</li>
            </ul>
            {/* <p>
                {blog.MetaDescription}
                </p> */}
            <div class="link-btn">
                <a href={`/blog/${blog.URL}`} class="theme-btn btn-style-five">Read More</a>
            </div>
        </div>
    </div>
</div>
})
                :
                null    
                }
    
                </div>
            </div>
        </section>
    </div>
   
    <button class="scroll-top scroll-to-target" data-target="html">
        <span class="fa fa-arrow-up"></span>
    </button>
<Footer/>
    
    </section>
  )
}

export default Blog
